<script setup lang="ts">
import { LayerControl, LayerControlUnwrapped } from '~/types/map'
import StationFilters from '@/components/data-filters/StationFilters.vue'
import { useMapStore } from '~/stores/map'
import { createSlug } from '~/stores/utils/filter-util'

const mapStore = useMapStore()
const layers = reactive<LayerControl[]>([])

function registerLayer(layer: LayerControlUnwrapped) {
  layers.push(layer)
  mapStore.activeLayers = layers
}

function updateLayerVisibility(layerIdentifier: string, visible: boolean) {
  const layer = layers.find((layer) => layer.identifier === layerIdentifier)
  if (!layer) return
  layer.visible = visible
}

const activeDatafilters = inject<Ref<string[]>>('activeDatafilters')

provide('layerControls', { registerLayer, updateLayerVisibility })
</script>
<template>
  <MapControlBox icon="pi-filter" label="Kartinställningar">
    <div v-if="activeDatafilters && activeDatafilters.length > 0">
      <h6 class="mt-2">Filter</h6>
      <StationFilters />
    </div>
    <fieldset class="mb-5">
      <legend class="flex align-items-center px-2 pb-2">Lager</legend>
      <div v-for="layer in layers" :key="layer.identifier" class="flex my-2">
        <Checkbox
          v-model="layer.visible"
          :binary="true"
          :input-id="createSlug(layer.name)"
          @on-change="updateLayerVisibility(layer.identifier, !layer.visible)"
        />
        <label :for="createSlug(layer.name)" class="ml-2">
          {{ layer.name }}
        </label>
      </div>
    </fieldset>
  </MapControlBox>
  <slot />
</template>
